import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import type { JobCardPreviewResponse } from '@jobos/shared';

/**
 * Fetch the job card payload for the HTML preview. Pass `enabled: false` while
 * the modal is closed — the request triggers a Google Calendar round-trip for
 * worker hours, so it should not fire on page load.
 */
export function useJobCardPreview(
  jobId: string,
  documentId: string | undefined,
  enabled: boolean
) {
  return useQuery({
    queryKey: ['job-card-preview', jobId, documentId ?? null],
    queryFn: () =>
      apiClient.post<JobCardPreviewResponse>('/job-cards/preview', { jobId, documentId }),
    enabled: enabled && !!jobId,
    staleTime: 0, // the breakdown may have just been saved; never serve a stale card
  });
}
